import type { IWorkpieceTypeRepository, WorkpieceTypeListQuery } from '@domain/data-contracts/workpiece-type-repository.interface';
import type { WorkpieceType } from '@domain/models/workpiece-type.interface';
import type { PagedResult } from '@domain/models/paging.interface';

export class WorkpieceTypesService {
  public constructor(private readonly repo: IWorkpieceTypeRepository) {}

  public list(query: WorkpieceTypeListQuery): Promise<PagedResult<WorkpieceType>> {
    return this.repo.list(query);
  }
}
